(() => {
  'use strict';
  const origins = new Set(['https://maps.gls-czech.cz','https://ps-maps.gls-czech.cz','https://ps-maps.gls-czech.com']);
  let active = null;
  window.botasGlsPick = function(button) {
    if (active || window.selectedCountry !== 'CZ' || window.shippingMethod !== 'gls_point_cz') return;
    const dialog=document.createElement('dialog');
    dialog.style.cssText='width:min(1100px,94vw);height:min(800px,90dvh);padding:16px;border:0;border-radius:20px;background:#fff;max-width:none';
    dialog.innerHTML='<div style="display:flex;justify-content:space-between;align-items:center"><strong>Vyberte výdejní místo nebo box GLS</strong><button type="button" aria-label="Zavřít mapu" style="font-size:28px;background:none;border:0">×</button></div><p role="status">Načítám mapu…</p><iframe title="Výdejní místa a boxy GLS" style="width:100%;height:calc(100% - 70px);border:0"></iframe>';
    document.body.append(dialog);active=dialog;
    const frame=dialog.querySelector('iframe'),status=dialog.querySelector('[role="status"]');let pending=false,closed=false;
    const close=()=>{closed=true;window.removeEventListener('message',receive);dialog.close();dialog.remove();active=null;button.focus();};
    const receive=async(event)=>{
      if(closed||pending||event.source!==frame.contentWindow||!origins.has(event.origin))return;
      const row=event.data?.parcelshop?.detail||event.data?.parcelshop;
      if(!row||typeof row.pclshopid!=='string')return;
      if(row.ctrcode&&row.ctrcode!=='CZ'){status.textContent='Vyberte místo v Česku.';return;}
      pending=true;status.textContent='Ověřuji výdejní místo…';
      try{
        const r=await fetch('https://vasky.cz/a/api/storefront/checkout/gls-point?'+new URLSearchParams({id:row.pclshopid,country:'CZ'}),{signal:AbortSignal.timeout(12000)});
        const j=await r.json();if(!r.ok||!j.success)throw Error(j.error||'Místo se nepodařilo ověřit.');
        if(closed)return;if(window.shippingMethod!=='gls_point_cz'||window.selectedCountry!=='CZ'){close();return;}
        const p=j.data;
        window.__botasGlsPoint=p;window.pointId=p.point_id;window.pointName=p.point_name;
        button.closest('.botas-gls-widget').querySelector('[data-gls-selection]').textContent=`${p.point_name}, ${p.address}, ${p.zip} ${p.city}`;
        button.textContent='Změnit výdejní místo';window.clearShippingError?.();close();
      }catch(e){if(!closed)status.textContent=e.message;}finally{pending=false;}
    };
    window.addEventListener('message',receive);dialog.querySelector('button').addEventListener('click',close);
    dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
    frame.addEventListener('load',()=>{if(!pending)status.textContent='';});
    frame.src='https://maps.gls-czech.cz/?find=1&ctrcode=CZ';dialog.showModal();
  };
})();
